module.exports = __webpack_public_path__ + "static/media/preeti.jpg:Zone.d41d8cd9.Identifier";